(function() {
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    let [resource, config] = args;
    const url = typeof resource === 'string' ? resource : (resource instanceof Request ? resource.url : '');
    
    // Intercept any cart write operations (add, change, update)
    if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
      try {
        // Perform the request
        const response = await originalFetch(...args);
        
        if (response.ok) {
          // Fetch updated cart status
          const cartResponse = await originalFetch('/cart.js');
          const cart = await cartResponse.json();
          
          // Filter items of type RESERVE_PASS case-insensitively
          const reservePassItems = cart.items.filter(item => 
            item.product_type && item.product_type.toUpperCase() === 'RESERVE_PASS'
          );
          
          if (reservePassItems.length > 1) {
            // Find which variant ID was just added/targeted in this request
            let addedVariantId = null;
            if (config && config.body) {
              if (config.body instanceof FormData) {
                addedVariantId = config.body.get('id');
              } else if (typeof config.body === 'string') {
                try {
                  const params = new URLSearchParams(config.body);
                  addedVariantId = params.get('id') || JSON.parse(config.body).id;
                } catch(e) {}
              }
            }
            
            // Determine which item to keep and which to remove
            let itemToKeep = null;
            if (addedVariantId) {
              itemToKeep = reservePassItems.find(item => 
                String(item.variant_id) === String(addedVariantId) || String(item.id) === String(addedVariantId)
              );
            }
            
            // Fallback: if we couldn't match variant ID, keep the first item in Shopify's recency list
            if (!itemToKeep) {
              itemToKeep = reservePassItems[0];
            }
            
            const updates = {};
            reservePassItems.forEach(item => {
              if (item.key !== itemToKeep.key) {
                updates[item.key] = 0;
              }
            });
            
            // Extract sections from original request to make sure theme sections refresh correctly
            let sections = null;
            if (config && config.body) {
              if (config.body instanceof FormData) {
                sections = config.body.get('sections');
              } else if (typeof config.body === 'string') {
                try {
                  const params = new URLSearchParams(config.body);
                  sections = params.get('sections') || JSON.parse(config.body).sections;
                } catch(e) {}
              }
            }
            
            const updatePayload = { updates };
            if (sections) {
              updatePayload.sections = sections;
            }
            
            const updateResponse = await originalFetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(updatePayload)
            });
            
            return updateResponse;
          }
        }
        
        return response;
      } catch (err) {
        console.error('Reserve Pass validation error:', err);
      }
    }
    
    return originalFetch(...args);
  };

  // Double-safety page load checker for the cart page
  const validateReservePassCart = async () => {
    try {
      const res = await originalFetch('/cart.js');
      const cart = await res.json();
      const reservePassItems = cart.items.filter(item => 
        item.product_type && item.product_type.toUpperCase() === 'RESERVE_PASS'
      );
      
      if (reservePassItems.length > 1) {
        // Keep the first one and remove the rest
        const updates = {};
        for (let i = 1; i < reservePassItems.length; i++) {
          updates[reservePassItems[i].key] = 0;
        }
        
        await originalFetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ updates })
        });
        
        window.location.reload();
      }
    } catch (e) {
      console.error('Page load validate Reserve Pass check failed:', e);
    }
  };

  if (window.location.pathname.includes('/cart')) {
    document.addEventListener('DOMContentLoaded', validateReservePassCart);
  }
})();
